import script from "./VAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./VAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./VAttachment.vue?vue&type=style&index=0&id=1e1aaf68&lang=scss"

const __exports__ = script;

export default __exports__